import React from 'react';

import { Cta } from '~/components/flexible/Cta';
import { Careers } from '~/components/flexible/Careers';
import { Customers } from '~/components/flexible/Customers';
import { CustomerStories } from '../flexible/CustomerStories';
import { Faqs } from '~/components/flexible/Faqs';
import { Features } from '~/components/flexible/Features';
import { FeaturedProducts } from '~/components/flexible/FeaturedProducts';
import { FeaturedResources } from '~/components/flexible/FeaturedResources';
import { FeaturedTeam } from '~/components/flexible/FeaturedTeam';
import { Grid } from '~/components/flexible/Grid';
import { HowItWorks } from '~/components/flexible/HowItWorks';
import { Image } from '~/components/flexible/Image';
import { InsurancePlans } from '~/components/flexible/InsurancePlans';
import { InteractiveMap } from '~/components/flexible/InteractiveMap';
import { Logos } from '~/components/flexible/Logos';
import { Masthead } from '~/components/flexible/Masthead';
import { Mission } from '~/components/flexible/Mission';
import { Plans } from '~/components/flexible/Plans';
import { Program } from '~/components/flexible/Program';
import { Reviews } from '~/components/flexible/Reviews';
import { Rewards } from '~/components/flexible/Rewards';
import { Services } from '~/components/flexible/Services';
import { ShopBy } from '~/components/flexible/ShopBy';
import { Steps } from '~/components/flexible/Steps';
import { Support } from '~/components/flexible/Support';
import { TeamMemberFaqs } from '~/components/flexible/TeamMemberFaqs';
import { Testimonial } from '~/components/flexible/Testimonial';
import { Testimonials } from '~/components/flexible/Testimonials';
import { TextContent } from '~/components/flexible/TextContent';
import { TermsConditions } from '~/components/flexible/TermsConditions';
import { ThreeColumnBlocks } from '~/components/flexible/ThreeColumnBlocks';
import { TwoColumns } from '~/components/flexible/TwoColumns';
import { TwoColumnsCalculator } from '~/components/flexible/TwoColumnsCalculator';
import { TwoColumnLogos } from '~/components/flexible/TwoColumnLogos';
import { TwoColumnSlider } from '~/components/flexible/TwoColumnSlider';
import { Usps } from '~/components/flexible/Usps';
import { Values } from '~/components/flexible/Values';
import { Video } from '~/components/flexible/Video';

import { MeetSpecialist } from '~/components/flexible/MeetSpecialist';
import { LeadingClinic } from '~/components/flexible/LeadingClinic';
import { VisitUs } from '~/components/flexible/VisitUs';
import { LogosWithTitle } from '~/components/flexible/LogosWithTitle';
import { BetterHearing } from '~/components/flexible/BetterHearing';
import { StepsWithDescription } from '~/components/flexible/StepsWithDescription';
import { ScheduleConsultColumns } from '~/components/flexible/ScheduleConsultColumns';
import {BestPrice} from '~/components/flexible/BestPrice';

export const ContentRenderer = ({ prefix, content = [], layoutTracker = {} }) => {
  return (
    <>
      {content.map((layout, i) => {
        const layoutName = layout?.fieldGroupName?.replace(prefix, '');
        
        // Initialize layout tracker if it doesn't exist for this layout
        if (!layoutTracker[layoutName]) {
          layoutTracker[layoutName] = {
            totalLayoutCount: 0,
            currentLayoutCount: 0
          };
        }
        
        // Get total layouts of this type from tracker
        const totalLayouts = layoutTracker[layoutName].totalLayoutCount;
        let currentLayoutCount = layoutTracker[layoutName].currentLayoutCount + 1;
        
        // Create section class
        let sectionClass = `section-${layoutName}-${currentLayoutCount}`;
        
        // Update tracker if we're not at the last layout
        if (currentLayoutCount !== totalLayouts) {
          layoutTracker[layoutName].currentLayoutCount = currentLayoutCount;
        }
        
        let layoutWithClass = {...layout, sectionClass: sectionClass};

        if (layoutName === 'Cta') {
          return <Cta key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Careers') {
          return <Careers key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Customers') {
          return <Customers key={i} {...layoutWithClass} />;
        } else if (layoutName === 'CustomerStories') {
          return <CustomerStories key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Faqs') {
          return <Faqs key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Features') {
          return <Features key={i} {...layoutWithClass} />;
        } else if (layoutName === 'FeaturedProducts') {
          return <FeaturedProducts key={i} {...layoutWithClass} />;
        } else if (layoutName === 'FeaturedResources') {
          return <FeaturedResources key={i} {...layoutWithClass} />;
        } else if (layoutName === 'FeaturedTeam') {
          return <FeaturedTeam key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Grid') {
          return <Grid key={i} {...layoutWithClass} />;
        } else if (layoutName === 'HowItWorks') {
          return <HowItWorks key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Image') {
          return <Image key={i} {...layoutWithClass} />;
        } else if (layoutName === 'InsurancePlans') {
          return <InsurancePlans key={i} {...layoutWithClass} />;
        } else if (layoutName === 'InteractiveMap') {
          return <InteractiveMap key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Logos') {
          return <Logos key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Masthead') {
          return <Masthead key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Mission') {
          return <Mission key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Plans') {
          return <Plans key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Program') {
          return <Program key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Reviews') {
          return <Reviews key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Rewards') {
          return <Rewards key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Services') {
          return <Services key={i} {...layoutWithClass} />;
        } else if (layoutName === 'ShopBy') {
          return <ShopBy key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Steps') {
          return <Steps key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Support') {
          return <Support key={i} {...layoutWithClass} />;
        } else if (layoutName === 'TeamMemberFaqs') {
          return <TeamMemberFaqs key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Testimonial') {
          return <Testimonial key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Testimonials') {
          return <Testimonials key={i} {...layoutWithClass} />;
        } else if (layoutName === 'TextContent') {
          return <TextContent key={i} {...layoutWithClass} />;
        } else if (layoutName === 'TermsConditions') {
          return <TermsConditions key={i} {...layoutWithClass} />;
        } else if (layoutName === 'ThreeColumnBlocks') {
          return <ThreeColumnBlocks key={i} {...layoutWithClass} />;
        } else if (layoutName === 'TwoColumns') {
          return <TwoColumns key={i} {...layoutWithClass} />;
        } else if (layoutName === 'TwoColumnsCalculator') {
          return <TwoColumnsCalculator key={i} {...layoutWithClass} />;
        } else if (layoutName === 'TwoColumnLogos') {
          return <TwoColumnLogos key={i} {...layoutWithClass} />;
        } else if (layoutName === 'TwoColumnSlider') {
          return <TwoColumnSlider key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Usps') {
          return <Usps key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Values') {
          return <Values key={i} {...layoutWithClass} />;
        } else if (layoutName === 'Video') {
          return <Video key={i} {...layoutWithClass} />;
        } else if (layoutName === 'MeetSpecialist') {
          return <MeetSpecialist key={i} {...layoutWithClass} />;
        } else if (layoutName === 'LeadingClinic') {
          return <LeadingClinic key={i} {...layoutWithClass} />;
        } else if (layoutName === 'VisitUs') {
          return <VisitUs key={i} {...layoutWithClass} />;
        } else if (layoutName === 'BestPrice') {
          return <BestPrice key={i} {...layoutWithClass} />;
        } else if (layoutName === 'BetterHearing') {
          return <BetterHearing key={i} {...layoutWithClass} />;
        } else if (layoutName === 'LogosWithTitle') {
          return <LogosWithTitle key={i} {...layoutWithClass} />;
        } else if (layoutName === 'StepsWithDescription') {
          return <StepsWithDescription key={i} {...layoutWithClass} />;
        } else if (layoutName === 'ScheduleConsultColumns') {
          return <ScheduleConsultColumns key={i} {...layoutWithClass} />;
        } else {
          console.log('IMPLEMENT ', layoutName, layoutWithClass);
        }
        return null;
      })}
    </>
  );
};
